import { AuthContextProps } from "../components/auth-context";
import Customer from "../types/customer";
import { postData, putData } from "./core";

export default class ShopCustomerApi {
  static unauthorizedUri = "n/accounts/shopCustomer";
  static authorizedUri = "a/accounts/shopCustomer";
  context?: AuthContextProps;
  constructor(context?: AuthContextProps) {
    this.context = context;
  }
  post(id: string) {
    return postData({
      uri: ShopCustomerApi.unauthorizedUri,
      id,
    });
  }
  put(data: Customer) {
    return putData({
      uri: ShopCustomerApi.authorizedUri,
      context: this.context,
      data,
    });
  }
}
